export default "__VITE_ASSET__BVVebK5o__"